import React from 'react'

// Query String Params
export const FTV_CAMPAIGN = 'ftv_campaign'
export const COUPON_PARAM = 'coupon'
export const HEADLINE = 'headline'
export const HEADLINE2 = 'headline2'
export const PACK = 'pack'
export const OFFER = 'offer'
export const IRAD = 'irad'
export const IRMP = 'irmp'
export const SHARED_ID = 'sharedid'
export const PROMO = 'promo'
export const ADDONS = 'addons' // NTS: maybe switch back to addons[]
export const AL = 'al'
export const TALKABLE_VISITOR_UUID = 'talkable_visitor_uuid'
export const PROMO_CODE = 'promocode'
export const PARAMS = 'params'
export const AB_CAMPAIGN = 'ab_campaign'
export const APP_SOURCE = 'app_source'
export const SPORT_ID = 'sportid'
export const LEAGUE_ID = 'leagueid'
export const TEAM_ID = 'teamid'

export const footballCTAURI = '/football'
export const streamTVCTAURI = '/streamtv'
export const defaultCTAURI = '/signup'
export const signInURI = '/signin'

export const imgixURI = 'https://assets-imgx.fubo.tv/marketing/lp/images/'
export const videoURI = 'https://assets.fubo.tv/marketing/lp/videos/'

export const ctaParamList = [
  FTV_CAMPAIGN,
  COUPON_PARAM,
  HEADLINE,
  HEADLINE2,
  PACK,
  OFFER,
  IRAD,
  IRMP,
  SHARED_ID,
  PROMO,
  ADDONS,
  AL,
  TALKABLE_VISITOR_UUID,
  PROMO_CODE,
  PARAMS,
  AB_CAMPAIGN,
  APP_SOURCE,
  SPORT_ID,
  LEAGUE_ID,
  TEAM_ID,
]

export const commonCtaText = {
  getAccess: 'Get access',
  startYourFreeTrial: 'Start your free trial', // old
  startWatching: 'Start watching',
  startForFree: 'Start for free',
  accederAhora: 'Acceder ahora',
  pruebaloGratis: 'Pruébalo gratis',
  startWatchingForFree: 'Start watching for free',
  getStarted: 'Get started',
}

export const commonSubtitleText = {
  onAnyDevice: 'On any device. Anytime. Anywhere.',
}

export const commonTitleText = {
  streamLiveTVSports: (
    <>
      Stream live <br />
      TV & sports
    </>
  ),
}

export const subtitleText = {
  epl: (
    <>
      Stream Premier League matches in 4K only on Fubo.
      <span className="desktop-line-break">Plus more world-class soccer.</span>
    </>
  ),
}

// Free Trial Flags
export const isUSFreeTrial = true
export const isCAFreeTrial = false
export const isLAFreeTrial = true

export const defaultCTA = {
  us: {
    freeTrial: {
      text: commonCtaText.startWatchingForFree,
      text_es: commonCtaText.pruebaloGratis,
      text_short: commonCtaText.startForFree,
    },
    noTrial: {
      text: commonCtaText.startWatching,
      text_es: commonCtaText.accederAhora,
      text_short: commonCtaText.startWatching,
    },
  },
  canada: {
    freeTrial: {
      text: commonCtaText.startWatchingForFree,
      text_es: commonCtaText.pruebaloGratis,
      text_short: commonCtaText.startForFree,
    },
    noTrial: {
      text: commonCtaText.getAccess,
      text_es: commonCtaText.accederAhora,
      text_short: commonCtaText.getAccess,
    },
  },
  latino: {
    freeTrial: {
      text: commonCtaText.startWatchingForFree,
      text_es: commonCtaText.pruebaloGratis,
      text_short: commonCtaText.startForFree,
    },
    noTrial: {
      text: commonCtaText.getAccess,
      text_es: commonCtaText.accederAhora,
      text_short: commonCtaText.getAccess,
    },
  },
}

// Remove all Free Trial Sections.
// Use regex in search.

// Notable exeptions with Free Trial text
// src/components/page/movers/components/SideBySideSection/index.js
// src/components/page/live/components/HeroLiveFeed/components/hero.js, const cta_subhead & preview_cta_text
// src/components/page/fubotv-plus-aaa/index.js, remove <PlanSection/> and <TrialReminder/> components

// Canada EPL Pages
export const CaEplDefaultCtaText = commonCtaText.getAccess

// Latino CTAs
export const LatinoDefaultCtaText = isLAFreeTrial
  ? defaultCTA.latino.freeTrial.text
  : defaultCTA.latino.noTrial.text

export const LatinoDefaultCtaTextShort = isLAFreeTrial
  ? defaultCTA.latino.freeTrial.text_short
  : defaultCTA.latino.noTrial.text_short

export const LatinoDefaultCtaText_ES = isLAFreeTrial
  ? defaultCTA.latino.freeTrial.text_es
  : defaultCTA.latino.noTrial.text_es

// Canada CTAs
export const CanadaDefaultCtaText = isCAFreeTrial
  ? defaultCTA.canada.freeTrial.text
  : defaultCTA.canada.noTrial.text

export const CanadaDefaultCtaTextShort = isCAFreeTrial
  ? defaultCTA.canada.freeTrial.text_short
  : defaultCTA.canada.noTrial.text_short

//Spain CTAs
export const SpainDefaultCtaText = commonCtaText.pruebaloGratis
